import './index.css'
import React from 'react';
import SortingVisualizer from './components/SortingVisualizer';
function App() {
  return (
    <div>
      <SortingVisualizer />
    </div>
  );
}
export default App;